// extracted by mini-css-extract-plugin
module.exports = {"alert":"OrderLine_alert__liytq","description":"OrderLine_description__GjRYC","delivery":"OrderLine_delivery__G0_mQ","row":"OrderLine_row__N17YT","column":"OrderLine_column___Jj5k"};